import Swal from 'sweetalert2';

/**
 * Handles the response of a form submission.
 * @async
 * @param {Object} props - The properties object.
 * @param {Object} props.resultAction - The result action object.
 * @param {string} props.successTitle - The success title string.
 * @param {string} props.navigatePath - The navigate path string.
 * @param {function} props.navigate - The navigate function.
 * @param {boolean} [props.navigateOnSuccess=true] - The navigate on success boolean.
 * @param {boolean} [props.closeDialog=false] - The close dialog boolean.
 * @param {function} [props.handleClose] - The handle close function.
 */
const handleFormResponse = async (props) => {
  const {
    resultAction,
    successTitle,
    navigatePath,
    navigate,
    navigateOnSuccess = true,
    closeDialog = false,
    handleClose,
    successDialog = true,
  } = props;

  if (resultAction.meta.requestStatus === 'fulfilled') {
    const resourceID = resultAction.payload.id;
    if (closeDialog) {
      handleClose();
    }

    if (!successDialog) {
      return resultAction.payload;
    }

    await Swal.fire({
      icon: 'success',
      title: successTitle,
      showConfirmButton: true,
    });

    if (navigateOnSuccess) {
      navigate(navigatePath.replace(':id', resourceID), { replace: false });
    }

    return resultAction.payload;
  }

  Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: resultAction.payload,
    showConfirmButton: true,
  });

  return false;
};

export default handleFormResponse;
